import React, {useContext, useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'

// Lazy load MiniCart - only needed on desktop when user clicks cart icon
const MiniCart = loadable(() => import('../components/mini-cart'), {
    ssr: false
})

/**
 * This is the context for managing the MiniCart.
 * Used in top level App component.
 */
export const MiniCartContext = React.createContext()
export const useMiniCartContext = () => useContext(MiniCartContext)
export const MiniCartProvider = ({children}) => {
    const miniCart = useMiniCart()
    // useBreakpointValue returns undefined during SSR, false on mobile, true on desktop
    // MiniCart only renders client-side on desktop (mobile goes directly to bag page)
    const isDesktop = useBreakpointValue({base: false, lg: true})

    return (
        <MiniCartContext.Provider value={miniCart}>
            {children}
            {isDesktop && <MiniCart />}
        </MiniCartContext.Provider>
    )
}
MiniCartProvider.propTypes = {
    children: PropTypes.node.isRequired
}

export const useMiniCart = () => {
    const [isOpen, setIsOpen] = useState(false)

    const {pathname} = useLocation()
    useEffect(() => {
        if (isOpen) {
            setIsOpen(false)
        }
    }, [pathname])

    return {
        isOpen,
        onOpen: () => {
            setIsOpen(true)
        },
        onClose: () => {
            setIsOpen(false)
        }
    }
}
